import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DashboardIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 3.36526C8.79895 3.36526 9.5979 3.4825 10.3968 3.717C13.1256 4.51784 15 7.02143 15 9.86526V12.3653C15 12.9176 14.5523 13.3653 14 13.3653H2C1.44772 13.3653 1 12.9176 1 12.3653V9.86526C1 7.02143 2.8744 4.51784 5.60315 3.717C6.4021 3.4825 7.20105 3.36526 8 3.36526ZM7.05132 11.0491C6.87667 11.573 7.15983 12.1393 7.68377 12.314C8.20772 12.4886 8.77404 12.2055 8.94868 11.6815C9.87634 7.95466 10.1655 6.03301 9.81623 5.91658C9.46693 5.80014 8.5453 7.51096 7.05132 11.0491ZM2.75 10.3653C2.33579 10.3653 2 10.7011 2 11.1153C2 11.5295 2.33579 11.8653 2.75 11.8653C3.16421 11.8653 3.5 11.5295 3.5 11.1153C3.5 10.7011 3.16421 10.3653 2.75 10.3653ZM13.25 10.3653C12.8358 10.3653 12.5 10.7011 12.5 11.1153C12.5 11.5295 12.8358 11.8653 13.25 11.8653C13.6642 11.8653 14 11.5295 14 11.1153C14 10.7011 13.6642 10.3653 13.25 10.3653ZM3.75 6.36526C3.33579 6.36526 3 6.70105 3 7.11526C3 7.52947 3.33579 7.86526 3.75 7.86526C4.16421 7.86526 4.5 7.52947 4.5 7.11526C4.5 6.70105 4.16421 6.36526 3.75 6.36526ZM12.25 6.36526C11.8358 6.36526 11.5 6.70105 11.5 7.11526C11.5 7.52947 11.8358 7.86526 12.25 7.86526C12.6642 7.86526 13 7.52947 13 7.11526C13 6.70105 12.6642 6.36526 12.25 6.36526ZM8 4.36526C7.58579 4.36526 7.25 4.70105 7.25 5.11526C7.25 5.52947 7.58579 5.86526 8 5.86526C8.41421 5.86526 8.75 5.52947 8.75 5.11526C8.75 4.70105 8.41421 4.36526 8 4.36526Z"
		/>
	</svg>
))
